export const PRIMARY = 'primary';
export const TRANSPARENT_ON_BACKGROUND = 'transparent-on-background';
export const TRANSPARENT_ON_PRIMARY = 'transparent-on-primary';
export const PRIMARY_TRANSPARENT_BACKGROUND = 'primary-transparent-background';
export const DEFAULT = 'default';
export const DEFAULT_ON_BACKGROUND = 'default-on-background';